import { POPUP } from '../types';

const initialState = {
  serverError: false,
  message: ''
};

const serverErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case POPUP.SET_SERVER_ERROR:
      return {
        serverError: true,
        message: action.payload
      };

    case POPUP.CLOSE_SERVER_ERROR:
      return {
        serverError: false,
        message: ''
      };

    default:
      return state;
  }
};

export default serverErrorReducer;